import {type Breakpoints, type Theme as MuiTheme} from '@mui/material/styles';
import useMuiMediaQuery from '@mui/material/useMediaQuery';
import '@famly/mf_theme';

export const useMediaQuery = (fn: (breakpoints: Breakpoints) => string) => {
    return useMuiMediaQuery<MuiTheme>(theme => fn(theme.breakpoints));
};
